import { ITag } from '@fluentui/react/lib/Pickers';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { removeReadOnly, Tag, TagCategory } from '../../../RootPost';
import Button from '../../shared/Button';
import TagsEditorBasic from './TagsEditorBasic';

export interface TagsEditorProps {
  tags: Tag[];
  onCancel: () => void;
  onSave: (addedTags: string[], removedTags: string[]) => void;
}

export default function TagsEditor(props: TagsEditorProps): JSX.Element {
  const [updatedTags, setUpdatedTags] = useState(props.tags.filter(removeReadOnly).map(x => ({ key: x.value, name: x.value } as ITag)));
  const [isValid, setIsValid] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const tagListChanged = (items?: ITag[]): void => {
    setUpdatedTags(items);
    setIsDirty(true);
  }

  const validationStateChanged = (isValid: boolean, message: string): void => {
    setIsValid(isValid);
  }

  const saveChanges = (): void => {
    const original = props.tags.filter(removeReadOnly).map(x => x.value);
    const updated = updatedTags.map(x => x.key as string);

    const added = updated.filter(x => original.indexOf(x) === -1);
    const removed = original.filter(x => updated.indexOf(x) === -1);

    props.onSave(added, removed);
  }

  return <Wrapper>
    <TagsEditorBasic
      tags={updatedTags}
      tagListChanged={tagListChanged}
      validationStateChanged={validationStateChanged}
    />

    <div className="buttons">
      <Button
        buttonType="link"
        size="compact"
        iconName="Save"
        disabled={!isValid || !isDirty}
        onClick={saveChanges}
      >
        Save
      </Button>

      <Button
        buttonType="link"
        size="compact"
        iconName="Cancel"
        onClick={props.onCancel}
      >
        Cancel
      </Button>
    </div>
  </Wrapper>
}

const Wrapper = styled.div`
  --vertical-gap: 0.8rem;

  display: flex;
  flex-direction: column;
  padding: var(--vertical-gap);
  padding-top: 0;
  padding-left: 0;

  .buttons {
    margin-top: 1.5rem;
    margin-left: var(--vertical-gap);
    margin-left: 3rem;

    >* + * {
      margin-left: 3rem;
    }
  }

  button {
    font-size: 1.6rem;
  }

  > * {
    margin-top: var(--vertical-gap);
    margin-left: var(--vertical-gap);
  }
`;
